import { Button, Row } from "antd";
import "./style.scss";
import { ReactNode, useMemo } from "react";
import { usePermissions } from "../../lib/hooks/usePermissions";

type TBtnsProps = {
  currentId: string | null;
  onSaveClick: (isNew: boolean, currentId: string | null) => Promise<void>;
  onCancelClick: () => void;
  onDeleteClick: (id: string) => void;
  isFormDisabled: boolean;
  controller: string;
  children?: ReactNode;
  isAlternate?: boolean;
  parentId?: string;
};

export const FormButtons = ({
  currentId,
  onSaveClick,
  onCancelClick,
  onDeleteClick,
  isFormDisabled,
  controller,
  children,
}: TBtnsProps) => {
  const { hasAccessByController } = usePermissions(controller);

  const isCloseDisabled: boolean = useMemo(() => {
    if (hasAccessByController(currentId !== null ? "Modify" : "Add")) {
      return isFormDisabled;
    }

    return false;
  }, [currentId, hasAccessByController, isFormDisabled]);

  return (
    <Row className="default-form-buttons w-100 pa-6 divider d-flex justify-space-between position-absolute">
      <div className="d-flex default-form-buttons-main">
        {hasAccessByController(currentId !== null ? "Modify" : "Add") && (
          <Button
            shape="round"
            type="primary"
            disabled={isFormDisabled}
            loading={isFormDisabled}
            onClick={() => onSaveClick(false, currentId)}
          >
            {currentId !== null ? "Save" : "Add"}
          </Button>
        )}
        {currentId === null && hasAccessByController("Add") && (
          <Button
            shape="round"
            disabled={isFormDisabled}
            loading={isFormDisabled}
            onClick={() => onSaveClick(true, currentId)}
          >
            Add & New
          </Button>
        )}
        <Button
          shape="round"
          disabled={isCloseDisabled}
          onClick={onCancelClick}
        >
          Cancel
        </Button>
      </div>
      <div>
        {currentId !== null && children}
        {currentId !== null && hasAccessByController("Delete") && (
          <Button
            type="link"
            disabled={isFormDisabled}
            onClick={() => onDeleteClick(currentId)}
          >
            Delete
          </Button>
        )}
      </div>
    </Row>
  );
};
